import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../../../base/browser/dom.js';
import { Widget } from '../../../base/browser/ui/widget.js';
import { renderHoverAction, HoverWidget } from '../../../base/browser/ui/hover/hoverWidget.js';
export var ContentHoverWidget = /*#__PURE__*/function (_Widget) {
  _inherits(ContentHoverWidget, _Widget);

  var _super = _createSuper(ContentHoverWidget);

  function ContentHoverWidget(id, editor, _hoverVisibleKey, _keybindingService) {
    var _this;

    _classCallCheck(this, ContentHoverWidget);

    _this = _super.call(this);
    _this._hoverVisibleKey = _hoverVisibleKey;
    _this._keybindingService = _keybindingService; // Editor.IContentWidget.allowEditorOverflow

    _this.allowEditorOverflow = true;
    _this._hover = _this._register(new HoverWidget());
    _this._id = id;
    _this._editor = editor;
    _this._isVisible = false;
    _this._stoleFocus = false;

    _this.onkeydown(_this._hover.containerDomNode, function (e) {
      if (e.equals(9
      /* Escape */
      )) {
        _this.hide();
      }
    });

    _this._register(_this._editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(36
      /* fontInfo */
      )) {
        _this.updateFont();
      }
    }));

    _this._editor.onDidLayoutChange(function (e) {
      return _this.layout();
    });

    _this.layout();

    _this._editor.addContentWidget(_assertThisInitialized(_this));

    _this._showAtPosition = null;
    _this._showAtRange = null;
    _this._stoleFocus = false;
    return _this;
  }

  _createClass(ContentHoverWidget, [{
    key: "isVisible",
    get: function get() {
      return this._isVisible;
    },
    set: function set(value) {
      this._isVisible = value;
      dom.toggleClass(this._hover.containerDomNode, 'hidden', !this._isVisible);
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._hover.containerDomNode;
    }
  }, {
    key: "showAt",
    value: function showAt(position, range, focus) {
      // Position has changed
      this._showAtPosition = position;
      this._showAtRange = range;

      this._hoverVisibleKey.set(true);

      this.isVisible = true;

      this._editor.layoutContentWidget(this); // Simply force a synchronous render on the editor
      // such that the widget does not really render with left = '0px'


      this._editor.render();

      this._stoleFocus = focus;

      if (focus) {
        this._hover.containerDomNode.focus();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this2 = this;

      if (!this.isVisible) {
        return;
      }

      setTimeout(function () {
        // Give commands a chance to see the key
        if (!_this2.isVisible) {
          _this2._hoverVisibleKey.set(false);
        }
      }, 0);
      this.isVisible = false;

      this._editor.layoutContentWidget(this);

      if (this._stoleFocus) {
        this._editor.focus();
      }
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      if (this.isVisible) {
        return {
          position: this._showAtPosition,
          range: this._showAtRange,
          preference: [1
          /* ABOVE */
          , 2
          /* BELOW */
          ]
        };
      }

      return null;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._editor.removeContentWidget(this);

      _get(_getPrototypeOf(ContentHoverWidget.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateFont",
    value: function updateFont() {
      var _this3 = this;

      var codeClasses = Array.prototype.slice.call(this._hover.contentsDomNode.getElementsByClassName('code'));
      codeClasses.forEach(function (node) {
        return _this3._editor.applyFontInfo(node);
      });
    }
  }, {
    key: "updateContents",
    value: function updateContents(node) {
      this._hover.contentsDomNode.textContent = '';

      this._hover.contentsDomNode.appendChild(node);

      this.updateFont();

      this._editor.layoutContentWidget(this);

      this._hover.onContentsChanged();
    }
  }, {
    key: "_renderAction",
    value: function _renderAction(parent, actionOptions) {
      var keybinding = this._keybindingService.lookupKeybinding(actionOptions.commandId);

      var keybindingLabel = keybinding ? keybinding.getLabel() : null;
      return renderHoverAction(parent, actionOptions, keybindingLabel);
    }
  }, {
    key: "layout",
    value: function layout() {
      var height = Math.max(this._editor.getLayoutInfo().height / 4, 250);

      var _this$_editor$getOpti = this._editor.getOption(36
      /* fontInfo */
      ),
          fontSize = _this$_editor$getOpti.fontSize,
          lineHeight = _this$_editor$getOpti.lineHeight;

      this._hover.contentsDomNode.style.fontSize = "".concat(fontSize, "px");
      this._hover.contentsDomNode.style.lineHeight = "".concat(lineHeight, "px");
      this._hover.contentsDomNode.style.maxHeight = "".concat(height, "px");
      this._hover.contentsDomNode.style.maxWidth = "".concat(Math.max(this._editor.getLayoutInfo().width * 0.66, 500), "px");
    }
  }]);

  return ContentHoverWidget;
}(Widget);
export var GlyphHoverWidget = /*#__PURE__*/function (_Widget2) {
  _inherits(GlyphHoverWidget, _Widget2);

  var _super2 = _createSuper(GlyphHoverWidget);

  function GlyphHoverWidget(id, editor) {
    var _this4;

    _classCallCheck(this, GlyphHoverWidget);

    _this4 = _super2.call(this);
    _this4._id = id;
    _this4._editor = editor;
    _this4._isVisible = false;
    _this4._domNode = document.createElement('div');
    _this4._domNode.className = 'monaco-hover hidden';

    _this4._domNode.setAttribute('aria-hidden', 'true');

    _this4._domNode.setAttribute('role', 'tooltip');

    _this4._showAtLineNumber = -1;

    _this4._register(_this4._editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(36
      /* fontInfo */
      )) {
        _this4.updateFont();
      }
    }));

    _this4._editor.addOverlayWidget(_assertThisInitialized(_this4));

    return _this4;
  }

  _createClass(GlyphHoverWidget, [{
    key: "isVisible",
    get: function get() {
      return this._isVisible;
    },
    set: function set(value) {
      this._isVisible = value;
      dom.toggleClass(this._domNode, 'hidden', !this._isVisible);
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    }
  }, {
    key: "showAt",
    value: function showAt(lineNumber) {
      this._showAtLineNumber = lineNumber;

      if (!this.isVisible) {
        this.isVisible = true;
      }

      var editorLayout = this._editor.getLayoutInfo();

      var topForLineNumber = this._editor.getTopForLineNumber(this._showAtLineNumber);

      var editorScrollTop = this._editor.getScrollTop();

      var lineHeight = this._editor.getOption(51
      /* lineHeight */
      );

      var nodeHeight = this._domNode.clientHeight;
      var top = topForLineNumber - editorScrollTop - (nodeHeight - lineHeight) / 2;
      this._domNode.style.left = "".concat(editorLayout.glyphMarginLeft + editorLayout.glyphMarginWidth, "px");
      this._domNode.style.top = "".concat(Math.max(Math.round(top), 0), "px");
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this.isVisible) {
        return;
      }

      this.isVisible = false;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return null;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._editor.removeOverlayWidget(this);

      _get(_getPrototypeOf(GlyphHoverWidget.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateFont",
    value: function updateFont() {
      var _this5 = this;

      var codeTags = Array.prototype.slice.call(this._domNode.getElementsByTagName('code'));
      var codeClasses = Array.prototype.slice.call(this._domNode.getElementsByClassName('code'));
      [].concat(_toConsumableArray(codeTags), _toConsumableArray(codeClasses)).forEach(function (node) {
        return _this5._editor.applyFontInfo(node);
      });
    }
  }, {
    key: "updateContents",
    value: function updateContents(node) {
      this._domNode.textContent = '';

      this._domNode.appendChild(node);

      this.updateFont();
    }
  }]);

  return GlyphHoverWidget;
}(Widget);